import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { defineComponent as _defineComponent } from 'vue';
import { useRoutesStore } from '@/store/modules/routes';
import { translate } from '@/i18n';
import { handleMatched } from '@/utils/routes';

import { useRoute } from 'vue-router';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const route = useRoute();
    const routesStore = useRoutesStore();
    const {
      getRoutes: routes
    } = storeToRefs(routesStore);
    const breadcrumbList = computed(() => handleMatched(routes.value, route.path).filter(item => !item.meta.breadcrumbHidden));
    const handleTo = (path = '') => {
      return {
        path
      };
    };
    const __returned__ = {
      route,
      routesStore,
      routes,
      breadcrumbList,
      handleTo,
      get translate() {
        return translate;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});